import { useComputedColors } from "./useComputedColors"
import { useMemo } from "react"
import type { Appearance } from "@stripe/stripe-js"

export function useStripeAppearance(): Appearance {
  const { colors } = useComputedColors()

  return useMemo(() => {
    const { brand, ruby, tint0, tint2, tint3, tint5, tint8, tint10, topaz } =
      colors

    return {
      variables: {
        borderRadius: "8px",
        colorBackground: tint10,
        colorDanger: ruby,
        colorPrimary: brand,
        colorTextSecondary: tint2,
        focusBoxShadow: `0 0 2px ${topaz}`,
        focusOutline: `1px solid ${topaz}`,
        fontSizeSm: "14px",
        colorText: tint0,
      },
      rules: {
        ".AccordionItem": {
          border: "unset",
          boxShadow: "unset",
          padding: "1rem",
          fontSize: "var(--fontSizeBase)",
          fontWeight: "normal",
          color: tint0,
        },
        ".AccordionItem--selected": {
          color: tint0,
          fontWeight: "500",
        },
        ".Action": { fontWeight: "500" },
        ".Label": { marginBottom: "0.5rem" },
        ".Input": {
          borderColor: tint5,
          boxShadow: "unset",
          paddingTop: "10px",
          paddingBottom: "10px",
          borderRadius: "4px",
        },
        ".Input:focus-visible": { borderColor: tint5 },
        ".Input--invalid": { boxShadow: "unset" },
        ".PickerItem": {
          borderColor: tint5,
          boxShadow: "unset",
          fontSize: "var(--fontSizeSm)",
          padding: "0.5rem",
        },
        ".PickerItem:focus-visible": { borderColor: tint5 },
        ".PickerItem:hover": {
          backgroundColor: tint8,
          borderColor: tint2,
        },
        ".PickerItem--selected": { boxShadow: "unset" },
        ".PickerItem--selected:hover": { boxShadow: "unset" },
        ".RadioIconInner--checked": { fill: tint10 },
        ".RadioIconOuter": {
          fill: tint10,
          strokeWidth: "5",
          stroke: tint3,
        },
        ".RadioIconOuter--checked": {
          stroke: brand,
          strokeWidth: "30",
        },
        ".Tab": {
          borderColor: tint5,
          boxShadow: "unset",
        },
        ".Tab:hover": {
          backgroundColor: tint8,
          borderColor: tint2,
        },
        ".TabIcon": { fill: tint2 },
      },
    }
  }, [colors])
}
